
import * as signalR from "@aspnet/signalr";
import store from '@/store';
class HubService{
    
    private hubConnection: any;
    constructor() {
        this.hubConnection =  this.getConnection();
    }
    private getConnection(){
        if(!this.hubConnection)
            this.hubConnection = store.getters.hubConnection;

        return this.hubConnection;
    }
    
    public async start(){
        if (!store.getters.isLoggedIn) {
            return;
        }

        if (this.hubConnection.state === signalR.HubConnectionState.Disconnected) {
            try {
                await this.hubConnection.start();
            } catch (err) {
                setTimeout(() => {
                    if (store.getters.isLoggedIn) {
                        this.start();
                    }
                }, 5000);
            }
        }
    }

    on(method: string, callback: (payload: any) => void){
        this.hubConnection.on(method, (payload: any) => callback(payload));
    }
    off(method: string, callback: (...args: any[]) => void) {
        this.hubConnection.off(method, callback);
    }
    onAppNotificaction(callback: (userIDs: number[], refId: number) => void) {
        this.hubConnection.on('APP_NOTIFICATION_RECEIVED', callback);
    }
    offAppNotificaction(callback: (userIDs: number[], refId: number) => void) {
        this.hubConnection.off('APP_NOTIFICATION_RECEIVED', callback);
    }
    onUserMessageReceived(callback: (userIDs: number[])=>void){
        this.hubConnection.on('messageReceived', callback);
    }
    onTramiteNotificationReceived(callback: (userId: number) => void) {
        this.hubConnection.on('tramiteNotificationReceived', callback);
    }
    onPsInfoActivityCreated(callback: (activity: any) => void) {
        this.hubConnection.on('psInfoActivityCreated', callback);
    }
    onAvisoUsuarioCreated(callback:(avisoId:number)=>void){
        this.hubConnection.on('avisoUsuario', callback);
    }
   
}
class HubInstance{
    private static hubService: HubService;
    static getHubServiceInstance(): HubService {
        if (!HubInstance.hubService) {
            HubInstance.hubService = new HubService();
        }
        return HubInstance.hubService;
    }
}
export default HubInstance.getHubServiceInstance();
